import { runDynamicCode } from '@aeppic/shared/dynamic/dynamic-code'
import { createControllerClass as createV3ControllerClass } from '@aeppic/dynamic-components-v3'

export default function createControllerClass(codeGroup, name, controllerClassCode, variablesToExpose, globals) {
  return createV3ControllerClass(codeGroup, name, controllerClassCode, variablesToExpose, globals, runDynamicCode)
}
